export const useStyles = (theme) => ({
  title: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  nameCustomerStyle: {
    outline: "none",
    width: "49%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  nameAuthorStyle: {
    outline: "none",
    width: "32%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  termStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  inputWithMargin: {
    width: "49%",
    marginRight: 15,
    [theme.breakpoints.between(960, 789)]: {
      marginRight: 15,
    },
    [theme.breakpoints.between(789, 539)]: {
      marginRight: 10,
    },
    [theme.breakpoints.down(539)]: {
      width: "100%",
    },
  },
  inputWithoutMargin: {
    width: "49%",
    [theme.breakpoints.down(539)]: {
      width: "100%",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
});
